import { useEffect, useRef } from 'react';

const useUpdateEffect: typeof useEffect = (effect, deps) => {
  const isFirstMountRef = useRef(true);

  useEffect(
    () => {
      if (!isFirstMountRef.current) {
        return effect();
      }
      isFirstMountRef.current = false;
      return undefined;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps,
  );
};

export default useUpdateEffect;
